import React from "react";
import { Notice } from "./styles";

const ProvinceSelectionControl: React.FC = () => {
  return (
    <Notice>
      By selecting regions below, you are indicating that only orders with ship-to addresses within these regions should
      be synced into the GoBolt system. In the event that an order has a ship-to address that falls outside of the
      specified regions, it will be blocked from entering the GoBolt system.
    </Notice>
  );
};

export default ProvinceSelectionControl;
